<script>
import BaseModal from '@/vcs/_shared/modals/BaseModal.vue'
import { XIcon } from 'vue-feather-icons'
import ingHelper from '@/assets/images/ingHelper.png'

export default {
  components: { XIcon },
  extends: BaseModal,
  data: function () {
    return {
      ingHelper
    }
  }
}
</script>

<template lang="pug">
span
  .modal-header
    x-icon(size="1.5x" @click="close(false)")
  .modal-body.p-0
    img.w-100(alt="Help image" :src="ingHelper")
  //- .modal-footer.fixed
  //-   .row.h-100
  //-     .col-12.col-lg-4.offset-lg-4.h-100.d-flex.align-items-center
  //-       button.btn.btn-primary.btn-block(type="button" v-ea-click="() => {close(true)}") Rozumiem
</template>

<style lang="scss" scoped></style>
